module.exports = "/_next/static/images/img__card-1-touch-345136dfc3ba09df5a3ac7ddcbf1983f.png";